// extracted by mini-css-extract-plugin
export var button = "confirmation-modal-module--button--7YRnk";
export var buttonClose = "confirmation-modal-module--button-close--P2jSA";
export var buttons = "confirmation-modal-module--buttons--1P+8L";
export var closeButton = "confirmation-modal-module--close-button--JGzIa";
export var confirmation = "confirmation-modal-module--confirmation--SeTX9";
export var contentBox = "confirmation-modal-module--content-box--UVmBT";
export var emotics = "confirmation-modal-module--emotics--Fuitt";
export var reverse = "confirmation-modal-module--reverse--dM8Qm";
export var titleText = "confirmation-modal-module--title-text--BtFL6";